import { render } from "./CustomerStories.vue?vue&type=template&id=d3117d18&scoped=true&ts=true"
import script from "./CustomerStories.vue?vue&type=script&lang=ts"
export * from "./CustomerStories.vue?vue&type=script&lang=ts"

import "./CustomerStories.vue?vue&type=style&index=0&id=d3117d18&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3117d18"]])

export default __exports__